<div class="tile-for-cart">
    <div class="tile-for-cart__inner">
        <shared-common-item class="tile-for-cart__item" [description]="description$ | async"
            [subDescription]="(specialInstructions$ | async)" [edit]="true" [title]="title" [quantity]="quantity$ | async"
            [total]="total$ | async" (onEdit)="handleEdit($event)" (onIncrement)="handleIncrement($event)"
            (onDecrement)="handleDecrement($event)" (onRemove)="handleRemove($event)">
        </shared-common-item>
    </div>
</div>
